import { Backdrop, CircularProgress } from '@mui/material';

type LoadingOverlayProps = {
  loading: boolean;
};

export function LoadingOverlay({ loading }: LoadingOverlayProps) {
  return (
    <Backdrop open={loading} style={{ zIndex: 1300, color: 'red' }}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}
